<template>
  <div>
    <div>支付跳转中......</div>
    <form :action="formUrl" method="post" id="form" class="form">
      <input type="hidden" v-for="(em,key,index) in formData" :name="key" :value="em" :key="index"/>
    </form>
  </div>
</template>

<script>
export default {
  name: 'b2b',
  data () {
    return {
      formData: {},
      formUrl: ''
    }
  },
  beforeMount () {
    const data = JSON.parse(localStorage.getItem('b2b'))
    console.log(data)
    this.formUrl = data.PostUrl
    delete data.PostUrl
    this.formData = data
    setTimeout(() => {
      document.getElementById('form').submit()
    }, 200)
  },
  methods: {}
}
</script>

<style scoped>

</style>
